<dx-popup
  title="Gestion du stock minimum"
  [visible]="displayDialog"
  (onHidden)="closeDialog()"
  [height]="'auto'"
>
  <div class="custom-button-container-right mb-2 ">
    <dx-number-box
      label="Quantité stock minimum"
      [(value)]="stockMinimumAmount"
    >
    </dx-number-box>
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      label="Appliquer en masse"
      (onClick)="appliquerEnMasse()"
    >
    </yo-button>
  </div>

  <dx-data-grid
    #grid
    [dataSource]="stockMinimumList"
  >
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-selection showCheckBoxesMode="always" mode="multiple" selectAllMode="allPages"></dxo-selection>
    <dxo-editing mode="cell" [allowUpdating]="true" [confirmDelete]="false"></dxo-editing>
    <dxi-column dataField="site.libelle" caption="Site" [allowEditing]="false" [allowFiltering]="true"></dxi-column>
    <dxi-column dataField="amount"    [caption]="'Stock minimum ( en ' + produitDeclinaison.uniteDeMesure.abreviation + ' )'"
                [allowEditing]="true" [alignment]="'left'" [allowFiltering]="false"></dxi-column>
  </dx-data-grid>
  <div class="custom-button-container-right mt-2">
    <yo-button
      iconClass="fas fa-save"
      [theme]="ButtonThemeEnum.SAVE"
      label="Enregistrer"
      (onClick)="save()"
      type="submit">
    </yo-button>
  </div>

</dx-popup>
